<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Technology talks",
    "pageDesc":"Technology talks is Baianat event for techies where they can socialize and learn on the latest techniques.",
    "mantra":"Dive into the digital era. ",
    "mantraDesc":"Technology talks is a great chance for techies and geeks who would love to expand their network, get familiar with new technologies and how it could possibly be utilized for the different industries.",
    "sec1":"Why tech talks? ",
    "sec1Items":{
      "1":{
        "title":"Industry based",
        "desc":"We don't just share random technologies. We give you the recipes we have tried and worked for us in certain industries. "
      },
      "2":{
        "title":"Practical experience ",
        "desc":"Learning techniques and technologies require more than just info sessions. Together, we try new paths and explore the possibilities of certain technologies in real time workshops. "
      },
      "3":{
        "title":"Materials and documents ",
        "desc":"Have access to all the talks sessions, documents and materials, in addition to later bonding opportunities with the speakers."
      },
      "4":{
        "title":"Community picked speakers",
        "desc":"We give the power to our attendees every year to select some speakers based on their preferences and alter directly in the event agenda."
      }
    },
    "sec2":"Diversified topics for a holistic Agenda. ",
    "sec2Items":{
      "1":{
        "title":"Big data and analytics ",
        "desc":"Learn more on how to predict a business outcomes and future growth through analytics and data gathered from customers, employees and partners. "
      },
      "2":{
        "title":"Artificial intelligence ",
        "desc":"Talks on how to integrate AI into an organization and how to best utilize it to increase the efficiency of your business. "
      },
      "3":{
        "title":"Internet of things",
        "desc":"Learn on the latest findings of IoT and how to capitalize on each in your next project. "
      }
    },

    "cta":"Join our <br> tech talks!"
  },
  "ar": {
    "pageTitle":"مناقشات التكنولوجيا",
    "pageDesc":"مناقشات التكنولوجيا هي فعاليات بيانات للمتخصصين في التكنولوجيا حيث يمكنهم التواصل سويًا وتعلم أحدث التقنيات من خلال المناقشات.",
    "mantra":"تعمق في تقنيات| العصر الرقمي.",
    "mantraDesc":"تُعد مناقشات التكنولوجيا فرصة مميزة للمتخصصين الذين يرغبون في توسيع شبكاتهم والتعرف على التقنيات الجديدة وكيف يمكن استخدامها وتطبيقها  في الصناعات المختلفة.",
    "sec1":"لماذا تحضر مناقشات التكنولوجيا؟",
    "sec1Items":{
      "1":{
        "title":"محادثات قائمة على الصناعات",
        "desc":"لا نشارك التقنيات العشوائية فقط، بل نقدم لك الوصفات التي جربناها وعملنا عليها في بعض الصناعات."
      },
      "2":{
        "title":"الخبرة العملية ",
        "desc":"تتطلب تعلم التقنيات والتكنولوجيا أكثر من مجرد جلسة معلومات فقط. معًا، نجرب مسارات جديدة ونستكشف  إمكانيات بعض التقنيات في ورش العمل في الوقت الفعلي."
      },
      "3":{
        "title":"المواد والوثائق ",
        "desc":"يمكنك الوصول إلى جميع جلسات المحادثات والوثائق والمواد، بالإضافة إلى فرص الربط اللاحقة مع المتحدثين."
      },
      "4":{
        "title":"اختار المتحدثين الذين تفضلهم",
        "desc":"نعطي الحضور الفرصة كل عام في اختيار متحدثين الفعالية بناءً على تفضيلاتهم التغيير المباشر في جدول الأعمال."
      }
    },
    "sec2":"مواضيع متنوعة لجدول أعمال شامل.",
    "sec2Items":{
      "1":{
        "title":"البيانات الضخمة والتحليلات ",
        "desc":"تعرف على المزيد حول كيفية التنبؤ بنتائج العمل والنمو المستقبلي من خلال البيانات الضخمة والتحليلات التي تم جمعها من العملاء والموظفين والشركاء."
      },
      "2":{
        "title":"الذكاء الاصطناعي ",
        "desc":"محادثات حول كيفية دمج الذكاء الاصطناعي في المنظمة وكيفية الاستفادة منه على نحو أفضل من أجل زيادة كفاءة عملك."
      },
      "3":{
        "title":"انترنت الأشياء",
        "desc":"تعرف على أحدث النتائج التي وصل إليها إنترنت الأشياء وكيفية الاستفادة منه في مشروعك التالي. "
      }
    },

    "cta":"انضم إلى <br> مناقشات التكنولوجيا!"
  }
}
</i18n>
